import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="textRow">
              <h4>
                Grow Your Online Business Strategically, and Improve Customer
                Retention.
              </h4>
            </div>
          </div>
        </div>
      </div>
      <section className="btmFooter">
        <div className="copyRightRow">
          <div className="container">
          <div className="row">
            <div className="col-md-4">
              <div className="copyRightBox">
                <p>© 2025 • Vodote Techa</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="copyRightBox">
                <p>Call Us +91 99308 09662</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="social_row">
                <ul>
                  <li>
                    <a href="##">
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href="##">
                      <i className="fa fa-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href="##">
                      <i className="fa fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a href="##">
                      <i className="fa fa-youtube-play"></i>
                    </a>
                  </li>
                  <li>
                    <a href="##">
                      <i className="fa fa-linkedin"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          </div>
        </div>
      </section>
    </footer>
  );
}

export default Footer;
